import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { dangerContainedButtonSx } from "components/common/buttonStyles";
import { dialogActionsSx, dialogPaperSx, dialogTitleSx } from "components/common/dialogStyles";

function AppActionDialog({
  open,
  title,
  description,
  onClose,
  onConfirm,
  confirmLabel = "Aceptar",
  cancelLabel = "Cancelar",
  confirmColor = "primary",
  busy = false,
  confirmDisabled = false,
  children,
}) {
  const titleId = React.useId();
  const descriptionId = React.useId();
  const isNotice = !onConfirm;

  const handleClose = (event, reason) => {
    if (!busy) onClose(event, reason);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby={titleId}
      aria-describedby={descriptionId}
      fullWidth
      maxWidth="xs"
      PaperProps={{ sx: dialogPaperSx }}
    >
      <DialogTitle id={titleId} sx={dialogTitleSx}>
        {title}
      </DialogTitle>
      <DialogContent sx={{ px: { xs: 2, sm: 3 }, pt: "0 !important", pb: 2 }}>
        <Typography
          id={descriptionId}
          variant="body1"
          sx={{
            color: "text.secondary",
            fontSize: "1rem",
            lineHeight: 1.55,
            overflowWrap: "anywhere",
          }}
        >
          {description}
        </Typography>
        {children && <Box sx={{ mt: 2 }}>{children}</Box>}
      </DialogContent>
      <DialogActions sx={dialogActionsSx}>
        {!isNotice && (
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleClose}
            disabled={busy}
            sx={{ minHeight: 48, color: "text.primary", borderColor: "text.primary", px: 2 }}
          >
            {cancelLabel}
          </Button>
        )}
        <Button
          variant="contained"
          color={confirmColor}
          onClick={isNotice ? handleClose : onConfirm}
          disabled={busy || confirmDisabled}
          sx={{
            minHeight: 48,
            px: 2,
            ...(confirmColor === "error" && dangerContainedButtonSx),
          }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

AppActionDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  confirmColor: PropTypes.oneOf(["primary", "error"]),
  busy: PropTypes.bool,
  confirmDisabled: PropTypes.bool,
  children: PropTypes.node,
};

export default AppActionDialog;
